export enum AnalyticsProperties {
  TRACKING = 'tracking',
  CARRIER_ID = 'carrier_id',
  DELIVERY_ID = 'delivery_id',
  RETRIEVAL_ID = 'retrieval_id',
  LOCK_LABEL = 'lock_label',
  LOCATION_ID = 'location_id',
  BOX_NUMBER = 'box_number',
  BOX_ID = 'box_id',
  TRANSACTION_ID = 'transaction_id',
  CITIBOX_ID = 'citibox_id',
  PICKUP_ID = 'pickup_id',
  DROPOFF_ID = 'dropoff_id',
  EXPEDITION_ID = 'expedition_id',
  USER_ID = 'user_id',
  USER_AGENT = 'user_agent',
  PLATFORM = 'platform',
  CLIENT_CONTEXT = 'client_context',
  DETAILS = 'details',
  REASON = 'reason',
  DELIVERABLE = 'deliverable',
  IS_CAMERA_PERMISSION_DENIED = 'is_camera_permission_denied',
  METHOD = 'method',
  OPEN_CODE_FAILED = 'open_code_failed',
  OPEN_DOOR_AGAIN = 'open_door_again',
  CALL_AGENT = 'call_agent',
  EVENT_NAME = 'event_name',
  STATE = 'state',
  IS_ONLINE = 'is_online',
  INVALID_CARRIER_ID = 'invalid_carrier_id',
  INVALID_DROP_OFF_ID = 'invalid_drop_off_id',
  INVALID_QUERY_PARAMS = 'invalid_query_params',
  URL = 'url',
  INPUT = 'input',
  ATTEMPT = 'attempt',
  EXPECTED = 'expected',
  BUTTON_ID = 'button_id',
  BUTTON_TEXT = 'button_text',
  MS_SINCE_LAST_CLICK = 'ms_since_last_click',
  WEBAPP_VERSION = 'webapp_version'
}
